import { useEmployerOrganisationOptional } from '@yeshuman/sdk'

/** Org slug for billing/entitlements on job workspace (job owner, else active workspace). */
export function useEmployerJobOrgSlug(jobOrganisationSlug?: string | null): string | undefined {
  const empOrg = useEmployerOrganisationOptional()
  const fromJob = jobOrganisationSlug?.trim()
  if (fromJob) return fromJob
  return empOrg?.activeOrganisationSlug?.trim() || undefined
}
